import { createSlice } from "@reduxjs/toolkit";
import { startTransition } from "react";
export const assignToPartnerSlice = createSlice({
	name: "assignToPartner",
	initialState: {
		searchData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerTypeId: "-1",
			// partnerId: "-1",
			// regionId: "-1",
		},
		assignedPartnerLockerData: {
			operatorId: localStorage.getItem("user")
				? JSON.parse(localStorage.getItem("user")).operator_id
				: "",
			lockerId: "-1",
			partnerBranchId: "-1",
		},
		lockerTypeList: [],
		partnerList: [],
		unassignedLockerList: [],
		unassignedBranchList: [],
	},
	reducers: {
		getPartnerList: (state, actions) => {
			state.partnerList = actions.payload;
		},
		getLockerTypeList: (state, actions) => {
			state.lockerTypeList = actions.payload;
		},
		getUnassignedLockerList: (state, actions) => {
			state.unassignedLockerList = actions.payload;
		},
		getUnassignedBranchList: (state, actions) => {
			state.unassignedBranchList = actions.payload;
		},
		handleAssignedBranchLockerData: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "unassignedLocker":
					return {
						...state,
						assignedPartnerLockerData: {
							...state.assignedPartnerLockerData,
							lockerId: value,
						},
					};

				case "partnerBranchId":
					return {
						...state,
						assignedPartnerLockerData: {
							...state.assignedPartnerLockerData,
							partnerBranchId: value,
						},
					};
			}
		},
		handleOnChanged: (state, actions) => {
			const { name, value } = actions.payload;
			switch (name) {
				case "lockerTypeId":
					return {
						...state,
						searchData: {
							...state.searchData,
							lockerTypeId: value,
						},
					};
				case "partnerId":
					return {
						...state,
						searchData: {
							...state.searchData,
							partnerId: value,
						},
					};
				default:
					break;
			}
		},
		clearSearchData: (state) => {
			state.searchData = {
				operatorId: localStorage.getItem("user")
					? JSON.parse(localStorage.getItem("user")).operator_id
					: "",
				lockerTypeId: "-1",
				partnerId: "-1",
				partnerBranchId: "-1",
			};
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	getPartnerList,
	getLockerTypeList,
	getUnassignedLockerList,
	getUnassignedBranchList,
	handleOnChanged,
	clearSearchData,
	handleAssignedBranchLockerData,
} = assignToPartnerSlice.actions;

export default assignToPartnerSlice.reducer;
